export default [
    {
        title: 'Pemantauan Stok',
        route: 'pemantauan-sembako',
        icon: 'FileTextIcon',
    },
  ]
  